let currentPopup = undefined;
// Set popup contact 
if (!currentPopup && new URLSearchParams(window.location.search).get("contact_posted") == "true") {
	window.location.hash = "#popup.contact";
}

const requestInformationPopup = document.getElementById(
	"popup.requestInformation"
);

function openPopup(popup, id) {
	if (!body.classList.contains("noscroll"))
		body.classList.add("noscroll");

	closePopup();
	currentPopup = popup;
	popup.style.display = "flex";

	if (id === "popup.roomtour") {
		setIframeUrl("https://my.matterport.com/show/?m=hRRqTZWvHTS&play=1");
	}
}

function closePopup() {
	if (currentPopup == undefined) return;

	currentPopup.style.display = "none";
	currentPopup = undefined;

	if (window.location.hash.startsWith("#popup.")) {
		history.pushState("", document.title, window.location.pathname);
	}

	if (body.classList.contains("noscroll"))
		body.classList.remove("noscroll");
}

function checkForPopupHashInUrl() {
	// TODO: Need to sanitize?
	if (window.location.hash.startsWith("#popup.")) {
		let id = window.location.hash.substring(1);
		const popup_strings = id.split(".");
		let popup = document.getElementById(
			popup_strings[0] + "." + popup_strings[1]
		);

		if (popup == undefined) console.warn("Popup not found: " + id);
		else openPopup(popup, id);
	}
}

checkForPopupHashInUrl();

window.addEventListener("popstate", checkForPopupHashInUrl);

document.addEventListener('click', (e) => {
	if (e.target.matches('*[data-close-popup], *[data-close-popup] *')) {
		e.preventDefault();
		closePopup();
	}
})

document.querySelectorAll('.closePopup').forEach((el) => {
	el.addEventListener('click', function () {
		document.querySelectorAll('.popUp').forEach((el) => {
			el.style.display = "none";
		});
	});
});

document.body.addEventListener('click', function (e) {
	if (e.target.classList.contains('requestInformationButton')) {
		e.preventDefault();
		e.stopPropagation();

		window.currentProductInformationRequest = {
			title: e.target.dataset.product.trim(),
			type: e.target.dataset.productType.trim()
		};

		let product = e.target.dataset.product;
		document.querySelectorAll(".formProduct").forEach(form => {
			form.textContent = product;
		});
		document.querySelectorAll(".input-base").forEach(input => {
			input.value = product;
		})
		openPopup(requestInformationPopup);

		const onRequestInformationDataChanged = new CustomEvent("requestInformationDataChanged", {
			detail: {
				title: window.currentProductInformationRequest.title,
				type: window.currentProductInformationRequest.type
			}
		});

		window.dispatchEvent(onRequestInformationDataChanged);
	}
});